"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isInRect(point, rect, offset) {
    if (offset === void 0) { offset = { x: 0, y: 0 }; }
    return (point.x >= (rect.left - offset.x)
        && point.x <= (rect.right + offset.x)
        && point.y >= (rect.top - offset.y)
        && point.y <= (rect.bottom + offset.y));
}
exports.isInRect = isInRect;
function updateTransform(transform, key, value, suffix) {
    if (transform.indexOf(key + "(") >= 0) {
        var reg = new RegExp("(" + key + "[(]{1}[A-z0-9%-.]*[)]{1})", 'i');
        return transform.replace(reg, key + "(" + value + suffix + ")");
    }
    else {
        return transform + " " + key + "(" + value + suffix + ")";
    }
}
exports.updateTransform = updateTransform;
function createProp() {
    Object.defineProperty(HTMLElement.prototype, '_apolloId', {
        value: '-1',
        configurable: true,
        enumerable: true,
        writable: true,
    });
}
exports.createProp = createProp;
function isVisible(target) {
    if (!target.descriptor.checkVisibility)
        return true;
    var topMostLeftElement = document.elementFromPoint(target.boundingRect.left + 1, target.boundingRect.top + 1);
    var bottomMostRightElement = document.elementFromPoint(target.boundingRect.right - 1, target.boundingRect.bottom - 1);
    if (topMostLeftElement !== null && bottomMostRightElement !== null) {
        if (topMostLeftElement._apolloId === target.id)
            return true;
        if (bottomMostRightElement._apolloId === target.id)
            return true;
        var topMostLeftElementParent = topMostLeftElement.parentNode;
        var topLeftElementIsValid = false;
        while (topMostLeftElementParent
            && topMostLeftElementParent.nodeName.toLocaleLowerCase() !== 'body'
            && !topLeftElementIsValid) {
            if (topMostLeftElementParent._apolloId !== '-1' && topMostLeftElementParent._apolloId === target.id) {
                topLeftElementIsValid = true;
            }
            topMostLeftElementParent = topMostLeftElementParent.parentNode;
        }
        var bottomMostRightElementParent = bottomMostRightElement.parentNode;
        var bottomRightElementIsValid = false;
        while (bottomMostRightElementParent
            && bottomMostRightElementParent.nodeName.toLocaleLowerCase() !== 'body'
            && !bottomRightElementIsValid) {
            if (bottomMostRightElementParent._apolloId !== '-1' && bottomMostRightElementParent._apolloId === target.id) {
                bottomRightElementIsValid = true;
            }
            bottomMostRightElementParent = bottomMostRightElementParent.parentNode;
        }
        return topLeftElementIsValid || bottomRightElementIsValid;
    }
    else {
        return false;
    }
}
exports.isVisible = isVisible;
function emitEvent(id, payload) {
    var init = {};
    init.detail = payload;
    var customEvent = new CustomEvent(id, init);
    window.dispatchEvent(customEvent);
}
exports.emitEvent = emitEvent;
